import { clsx } from 'clsx';
import classes from './Label.module.css.js';
import React from 'react';
import { jsx } from 'react/jsx-runtime';
import Box from '../Box/Box.js';

const Label = /*#__PURE__*/React.forwardRef(function Label({
  as,
  size = 'small',
  variant = 'default',
  className,
  ...rest
}, ref) {
  const Component = as || 'span';
  if (rest.sx) {
    return /*#__PURE__*/jsx(Box, {
      as: Component,
      className: clsx(className, classes.Label),
      "data-size": size,
      "data-variant": variant,
      ref: ref,
      ...rest
    });
  }
  return /*#__PURE__*/jsx(Component, {
    className: clsx(className, classes.Label),
    "data-size": size,
    "data-variant": variant,
    ...rest
  });
});

export { Label as default };
